import { HOME } from '../helpers/routes';

export const SET_SUCCESS = 'SET_SUCCESS';
export const SET_ERROR = 'SET_ERROR';
export const RESET_USER_MESSAGES = 'RESET_USER_MESSAGES';
export const MESSAGE_SHOWN = 'MESSAGE_SHOWN';

function dispatchSetSuccess({ text, link = HOME, showPushdown = false } = {}) {
  return {
    type: SET_SUCCESS,
    payload: {
      text,
      link,
      showPushdown,
    },
  };
}

function dispatchSetError({ text, showModal = false } = {}) {
  return {
    type: SET_ERROR,
    payload: {
      text,
      showModal,
    },
  };
}

function dispatchResetUserMessages() {
  return {
    type: RESET_USER_MESSAGES,
  };
}

function dispatchMessageShown() {
  return {
    type: MESSAGE_SHOWN,
  };
}

export const setSubmit = () => dispatch => dispatch(dispatchResetUserMessages());
export const setSuccess = success => dispatch => dispatch(dispatchSetSuccess(success));
export const setError = error => dispatch => dispatch(dispatchSetError(error));
export const resetUserMessages = () => dispatch => dispatch(dispatchResetUserMessages());
export const messageShown = () => dispatch => dispatch(dispatchMessageShown());
